import React, { useState, useEffect } from 'react';
import './TranscriptNameEditDialog.css';

const TranscriptNameEditDialog = ({
  isOpen,
  currentName,
  onSave,
  onClose,
  validationError = null
}) => {
  const [value, setValue] = useState('');

  useEffect(() => {
    if (isOpen) {
      setValue(currentName || '');
    }
  }, [isOpen, currentName]);

  const handleSave = () => {
    const trimmed = value.trim();
    if (trimmed) {
      onSave(trimmed);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="popup-overlay" onClick={onClose}></div>
      <div className="popup-modal">
        <div className="popup-modal-content">
          <button className="popup-close" onClick={onClose}>×</button>
          <h4>Edit Transcript Name</h4>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
            className={`transcript-name-edit-input ${validationError ? 'error' : ''}`}
            placeholder="Enter transcript name"
          />
          {validationError && (
            <div className="validation-error">{validationError}</div>
          )}
          <div className="popup-modal-actions">
            <button
              onClick={onClose}
              className="popup-modal-button popup-modal-button-secondary"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="popup-modal-button popup-modal-button-primary"
              disabled={!value.trim()}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TranscriptNameEditDialog;
